module.exports = "<div class=\"content-wrapper\" style=\"min-height:1024px\">\r\n\r\n    <!---->\r\n    <!-- -->\r\n\r\n\r\n    <!-- Your Page Content Here -->\r\n    <!--<router-outlet></router-outlet>-->\r\n\r\n    <app-parentformconatiner></app-parentformconatiner>\r\n\r\n\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shell/Parent-Portal/parentcontainer/parentcontainer.component.html
// module id = 1219
// module chunks = 322